module.exports = __webpack_public_path__ + "img/nevill_b4.a061916b.jpg";